import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export interface Comment {
  id: string;
  project_id: string;
  entity_type: string;
  entity_id: string;
  parent_id: string | null;
  author_id: string;
  author_name: string;
  body: string;
  created_at: string;
  edited_at: string | null;
  resolved: boolean;
}

export async function getComments(
  projectId: string,
  entityType: string,
  entityId: string
): Promise<Comment[]> {
  const { data } = await axios.get(`${BASE}/api/projects/${projectId}/comments`, {
    params: { entity_type: entityType, entity_id: entityId },
  });
  return data;
}

export async function createComment(
  projectId: string,
  entityType: string,
  entityId: string,
  body: string
): Promise<Comment> {
  const { data } = await axios.post(`${BASE}/api/projects/${projectId}/comments`, {
    entity_type: entityType,
    entity_id: entityId,
    body,
  });
  return data;
}

export async function updateComment(
  projectId: string,
  commentId: string,
  updates: { body?: string; resolved?: boolean }
): Promise<Comment> {
  const { data } = await axios.patch(
    `${BASE}/api/projects/${projectId}/comments/${commentId}`,
    updates
  );
  return data;
}

export async function deleteComment(projectId: string, commentId: string): Promise<void> {
  await axios.delete(`${BASE}/api/projects/${projectId}/comments/${commentId}`);
}
